import React from "react";
import { Plan } from "../../../@types";
import { CollapsibleBox } from "../../../components";
import {
  useTranslate,
  isMedicareAdvantageType,
  getBenefitCost,
} from "../../../helpers";
import { shouldSuppressPlanBenefits } from "../../../helpers/planHelpers";
import { PreviewContext } from "../../../helpers";
import { SubSectionTable } from "./helper";
import { Ga4Event } from "../../../helpers/analytics";

const OopcMaximumMATable: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  const t = useTranslate();
  const previewMode = React.useContext(PreviewContext);
  const suppressed = shouldSuppressPlanBenefits(plan);

  const checkSuppressed = (value: unknown) => {
    return suppressed ? t("suppressed_plan_benefit") : value;
  };

  const headerTitle = t("plan_details.overview.oopc_maximum");

  // porting the logic from "old" overview code
  const getMedicareAdvantageData = () => {
    const label = t("plan_details.overview.oopc_maximum");
    return [
      {
        label: (
          <div className="ds-u-font-weight--bold">
            <CollapsibleBox
              labelId="plan_details.overview.oopc_maximum"
              tealiumProps={{
                event_action: "Plan Details Help Caret",
                event_label: `${headerTitle}|${label}`,
              }}
              ga4Props={{
                event_name: Ga4Event.PLAN_DETAILS_HELP_CARET_CLICKED,
                header: label,
              }}
              open={previewMode}
            >
              <span className="ds-u-font-weight--normal">
                {t("plan_details.overview.oopc_maximum.definition")}
              </span>
            </CollapsibleBox>
          </div>
        ),
        value: checkSuppressed(
          getBenefitCost(t, { plan, benefit: "maximum_oopc" })
        ),
      },
    ];
  };

  return (
    <SubSectionTable data={getMedicareAdvantageData()} caption={headerTitle} />
  );
};

export const OopcMaximum: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  // do not display MaximumOopc for PDP plans
  if (!isMedicareAdvantageType(plan.plan_type)) {
    return null;
  }

  return (
    <div>
      <OopcMaximumMATable plan={plan} />
    </div>
  );
};
